export enum InvestmentType {
    InvestorInvestment = 1,
    IssuerInvestment = 2
}